import ClearIcon from './ClearIcon';

export default ClearIcon;
